// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/index." + {"98":"ed1c6c9016d283dd6973","162":"e982a6c13e37677b83b8","397":"63bf2bf351718a57d1ca","509":"147e5378f466a4c040a6","584":"9193c14a0703c7c07163","971":"259fb49a44040169986b"}[chunkId] + ".js";
};